<template>
  <div
    v-if="facebookPostLink && facebookPostLink.length > 0"
    class="text-xs-center small my-4"
    style="font-size: small"
  >
    {{ $t('This message was reply automatically.') }}
    <v-menu v-model="showMenu" absolute offset-y style="max-width: 600px">
      <template v-slot:activator="{ on }">
        <a target="_blank" v-on="on">
          {{ $t('Go to post') }}
        </a>
      </template>

      <v-list>
        <v-list-tile
          v-for="(item, index) in facebookPostLink"
          :key="index"
          :href="item"
          target="_blank"
        >
          <v-list-tile-title>ลิงค์ {{ index + 1 }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    facebookPostLink() {
      const link = []
      if (this.value.comment_id) {
        link.push(`https://www.facebook.com/${this.value.comment_id}`)
      }
      if (this.value.postid) {
        link.push(`https://www.facebook.com/${this.value.postid}`)
        try {
          const postid = this.value.postid ? this.value.postid.split('_') : null
          if (postid && postid.length > 1) {
            link.push(`https://www.facebook.com/${postid[0]}/posts/${postid[1]}`)
          } else return null
        } catch (error) {
          console.error(error)
        }
      }
      return link
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatFacebookPostLink.vue